import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {
    auth,
    facebookAuthProvider,
    githubAuthProvider,
    googleAuthProvider,
    twitterAuthProvider
} from "firebase/firebase";
import {
    SIGNIN_FACEBOOK_USER,
    SIGNIN_GITHUB_USER,
    SIGNIN_GOOGLE_USER,
    SIGNIN_TWITTER_USER,
    SIGNIN_USER,
    SIGNOUT_USER,
    SIGNUP_USER,
    REQ_REFRESH_TOKEN,
    REQ_CREATE_TOKEN,
    GET_REFRESH_TOKEN,
    GET_CREATE_TOKEN,
    SET_MENU,
    BASE_URL_APIv5,
    BASE_URL_OSLOG,
    BASE_URL_JAVAZ_API
} from "constants/ActionTypes";
import {showAuthMessage, userSignInSuccess, userSignOutSuccess, userSignUpSuccess} from "actions/Auth";
import {
    userFacebookSignInSuccess,
    userGithubSignInSuccess,
    userGoogleSignInSuccess,
    userTwitterSignInSuccess
} from "../actions/Auth";

import axios from 'axios'

const createUserWithEmailPasswordRequest = async (email, password) =>
    await  auth.createUserWithEmailAndPassword(email, password)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithEmailPasswordRequest = async (email, password) =>
    await  auth.signInWithEmailAndPassword(email, password)
        .then(authUser => authUser)
        .catch(error => error);

// const signOutRequest = async () =>
//     await  auth.signOut()
//         .then(authUser => authUser)
//         .catch(error => error);


const signInUserWithGoogleRequest = async () =>
    await  auth.signInWithPopup(googleAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithFacebookRequest = async () =>
    await  auth.signInWithPopup(facebookAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithGithubRequest = async () =>
    await  auth.signInWithPopup(githubAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInUserWithTwitterRequest = async () =>
    await  auth.signInWithPopup(twitterAuthProvider)
        .then(authUser => authUser)
        .catch(error => error);

const signInWithUsernamePasswordApi = async(username, password) => {

    const param = JSON.stringify({username, password})

    return await axios.post(`${BASE_URL_JAVAZ_API}/user/login`, param)
                .then((response) =>  response )
                .catch((error) => error.response )
}

const signInWithUsernamePasswordApi2 = async(username, password) => {

    const URL = `${BASE_URL_OSLOG}/embedd/auth?username=${username}&password=${password}&embedd=true`;
    //const URL = `${BASE_URL_OSLOG}/auth?username=${username}&password=${password}&embedd=true`;
    //const URL = `${BASE_URL_OSLOG}/app/auth?username=${username}&password=${password}&embedd=true`;
    // const URL = `${BASE_URL_OSLOG}/lintasarta/auth?username=${username}&password=${password}&embedd=true`;
    // const URL = `${BASE_URL_OSLOG}/embedd/auth-apikey?apikey=12e70a6f-08ec-4b95-840c-40acb6c9b619&company=323`;
    console.log(URL)

    return await axios({
        headers: {
            'Accept': 'application/json',
        },
        method: 'get',
        url: URL,
        withCredentials: true,
    }).then((response) => response).catch((error) => error.response);

}

const getMenuAfterLogin = async (rolename, token) => {
    // console.log(`token: ${token}`)
    return await axios.get(`${BASE_URL_APIv5}/roles-module-by-name/${rolename}`, {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    })
                .then((response) =>  response )
                .catch((error) => error.response )
                
}

const signOutRequest = async () =>{ 

    // return await axios.get('http://localhost:9000/logout')
    //         .then((res)=> res)
    
    //const URL = `${BASE_URL_OSLOG}/app/logout`;
    const URL = `${BASE_URL_OSLOG}/embedd/logout`;
    // console.log(URL)
    
    await axios({
        headers: {
            'Accept': 'application/json',
        },
        method: 'get',
        url: URL,
        withCredentials: true,
    }).then((response) => response).catch((error) => error.response);

    // await auth.signOut()
    //     .then(authUser => authUser)
    //     .catch(error => error);

    return 'ok';

}

function* createUserWithEmailPassword({payload}) {
    const {email, password} = payload;
    try {
        const signUpUser = yield call(createUserWithEmailPasswordRequest, email, password);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            // sessionStorage.setItem('user_id', signUpUser.user.uid);
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userSignUpSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signInUserWithGoogle() {
    try {
        const signUpUser = yield call(signInUserWithGoogleRequest);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            // sessionStorage.setItem('user_id', signUpUser.user.uid);
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userGoogleSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}


function* signInUserWithFacebook() {
    try {
        const signUpUser = yield call(signInUserWithFacebookRequest);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            // sessionStorage.setItem('user_id', signUpUser.user.uid);
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userFacebookSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}


function* signInUserWithGithub() {
    try {
        const signUpUser = yield call(signInUserWithGithubRequest);
        if (signUpUser.message) {
            yield put(showAuthMessage(signUpUser.message));
        } else {
            // sessionStorage.setItem('user_id', signUpUser.user.uid);
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userGithubSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}


function* signInUserWithTwitter() {
    try {
        const signUpUser = yield call(signInUserWithTwitterRequest);
        if (signUpUser.message) {
            if (signUpUser.message.length > 100) {
                yield put(showAuthMessage('Your request has been canceled.'));
            } else {
                yield put(showAuthMessage(signUpUser.message));
            }
        } else {
            // sessionStorage.setItem('user_id', signUpUser.user.uid);
            localStorage.setItem('user_id', signUpUser.user.uid);
            yield put(userTwitterSignInSuccess(signUpUser.user.uid));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signInUserWithEmailPassword({payload}) {
    const {email, password} = payload;
    try {
        
        const signInUserApi = yield call(signInWithUsernamePasswordApi, email, password);
        //const signInUserApi2 = yield call(signInWithUsernamePasswordApi2, email, password)
        //console.log("sign in oslog 4",signInUserApi2);

        if(signInUserApi)
            if (signInUserApi.status !== 200) {
                yield put(showAuthMessage(signInUserApi.data.message));
            } else {
                const {role_name, apikey} = signInUserApi.data.data
                const menu = yield call(getMenuAfterLogin, role_name, apikey)
                if (menu.data.status === true){
                    const {data_modules} = menu.data.data
                    const data_menu_obj = [
                        {
                            "id": 112488,
                            "module_name": "dashboard-vehicle",
                            "alias": "Beranda",
                            "module_path": "dashboard-vehicle",
                            "module_option": "origin",
                            "module_icon": "zmdi-home",
                            "is_active": true,
                            "parent_name": "dashboard-vehicle",
                            "features": [
                                {
                                    "name": "read",
                                    "status": true
                                },
                                {
                                    "name": "create",
                                    "status": true
                                },
                                {
                                    "name": "edit",
                                    "status": true
                                },
                                {
                                    "name": "delete",
                                    "status": true
                                },
                                {
                                    "name": "report",
                                    "status": true
                                }
                            ],
                            "children": []
                        },
                        {
                            "id": 112590,
                            "module_name": "master-data",
                            "alias": "Master Data",
                            "module_path": "master-data",
                            "module_option": "origin",
                            "module_icon": "zmdi-storage",
                            "is_active": true,
                            "parent_name": "master-data",
                            "features": [
                                {
                                    "name": "read",
                                    "status": true
                                },
                                {
                                    "name": "create",
                                    "status": true
                                },
                                {
                                    "name": "edit",
                                    "status": true
                                },
                                {
                                    "name": "delete",
                                    "status": true
                                },
                                {
                                    "name": "report",
                                    "status": true
                                }
                            ],
                            "children": [
                                {
                                    "id": 112584,
                                    "module_name": "user",
                                    "alias": "Pengguna",
                                    "module_path": "master-user",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-whatsapp",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112508,
                                    "module_name": "driver",
                                    "alias": "Operator",
                                    "module_path": "master-driver",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-accounts-alt",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 184324,
                                    "module_name": "pool-group",
                                    "alias": "Dinas",
                                    "module_path": "pool-group",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-dns",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112459,
                                    "module_name": "pool",
                                    "alias": "Kantor",
                                    "module_path": "pool",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-pin-drop",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112509,
                                    "module_name": "group-customer-point",
                                    "alias": "Rute",
                                    "module_path": "group-customer-point",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-globe",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112476,
                                    "module_name": "customer-point",
                                    "alias": "Tujuan",
                                    "module_path": "customer-point",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-layers",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112465,
                                    "module_name": "vehicle",
                                    "alias": "Aset",
                                    "module_path": "master-vehicle",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-twitch",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112529,
                                    "module_name": "gps",
                                    "alias": "GPS",
                                    "module_path": "master-gps",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-reddit",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112429,
                                    "module_name": "geofence",
                                    "alias": "Geofence",
                                    "module_path": "master-geofence",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-pin",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112586,
                                    "module_name": "tools",
                                    "alias": "Operation Tools",
                                    "module_path": "tools",
                                    "module_option": "embedd",
                                    "module_icon": "zmdi-widgets",
                                    "is_active": true,
                                    "parent_name": "master-data",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": [
                                        {
                                            "id": 112440,
                                            "module_name": "company",
                                            "alias": "Company",
                                            "module_path": "master-company",
                                            "module_option": "origin",
                                            "module_icon": "zmdi-balance",
                                            "is_active": true,
                                            "parent_name": "master-data",
                                            "features": [
                                                {
                                                    "name": "read",
                                                    "status": true
                                                },
                                                {
                                                    "name": "create",
                                                    "status": true
                                                },
                                                {
                                                    "name": "edit",
                                                    "status": true
                                                },
                                                {
                                                    "name": "delete",
                                                    "status": true
                                                },
                                                {
                                                    "name": "report",
                                                    "status": true
                                                }
                                            ],
                                            "children": []
                                        },
                                        {
                                            "id": 112505,
                                            "module_name": "master-menu",
                                            "alias": "Master Menu",
                                            "module_path": "master-menu",
                                            "module_option": "origin",
                                            "module_icon": "zmdi-menu",
                                            "is_active": true,
                                            "parent_name": "master-data",
                                            "features": [
                                                {
                                                    "name": "read",
                                                    "status": true
                                                },
                                                {
                                                    "name": "create",
                                                    "status": true
                                                },
                                                {
                                                    "name": "edit",
                                                    "status": true
                                                },
                                                {
                                                    "name": "delete",
                                                    "status": true
                                                },
                                                {
                                                    "name": "report",
                                                    "status": true
                                                }
                                            ],
                                            "children": []
                                        },
                                        {
                                            "id": 112564,
                                            "module_name": "package-menu",
                                            "alias": "Package Menu",
                                            "module_path": "package-menu",
                                            "module_option": "origin",
                                            "module_icon": "zmdi-layers",
                                            "is_active": true,
                                            "parent_name": "master-data",
                                            "features": [
                                                {
                                                    "name": "read",
                                                    "status": true
                                                },
                                                {
                                                    "name": "create",
                                                    "status": true
                                                },
                                                {
                                                    "name": "edit",
                                                    "status": true
                                                },
                                                {
                                                    "name": "delete",
                                                    "status": true
                                                },
                                                {
                                                    "name": "report",
                                                    "status": true
                                                }
                                            ],
                                            "children": []
                                        },
                                        {
                                            "id": 112449,
                                            "module_name": "role",
                                            "alias": "Role",
                                            "module_path": "user-management",
                                            "module_option": "origin",
                                            "module_icon": "zmdi-accounts-alt",
                                            "is_active": true,
                                            "parent_name": "master-data",
                                            "features": [
                                                {
                                                    "name": "read",
                                                    "status": true
                                                },
                                                {
                                                    "name": "create",
                                                    "status": true
                                                },
                                                {
                                                    "name": "edit",
                                                    "status": true
                                                },
                                                {
                                                    "name": "delete",
                                                    "status": true
                                                },
                                                {
                                                    "name": "report",
                                                    "status": true
                                                }
                                            ],
                                            "children": []
                                        },
                                        {
                                            "id": 112561,
                                            "module_name": "register-pod",
                                            "alias": "User POD",
                                            "module_path": "register-pod",
                                            "module_option": "origin",
                                            "module_icon": "zmdi-assignment-account",
                                            "is_active": true,
                                            "parent_name": "master-data",
                                            "features": [
                                                {
                                                    "name": "read",
                                                    "status": true
                                                },
                                                {
                                                    "name": "create",
                                                    "status": true
                                                },
                                                {
                                                    "name": "edit",
                                                    "status": true
                                                },
                                                {
                                                    "name": "delete",
                                                    "status": true
                                                },
                                                {
                                                    "name": "report",
                                                    "status": false
                                                }
                                            ],
                                            "children": []
                                        },
                                        {
                                            "id": 112583,
                                            "module_name": "master-sensor",
                                            "alias": "Sensor",
                                            "module_path": "master-sensor",
                                            "module_option": "origin",
                                            "module_icon": "zmdi-wrench",
                                            "is_active": true,
                                            "parent_name": "master-data",
                                            "features": [
                                                {
                                                    "name": "read",
                                                    "status": true
                                                },
                                                {
                                                    "name": "create",
                                                    "status": true
                                                },
                                                {
                                                    "name": "edit",
                                                    "status": true
                                                },
                                                {
                                                    "name": "delete",
                                                    "status": true
                                                },
                                                {
                                                    "name": "report",
                                                    "status": true
                                                }
                                            ],
                                            "children": []
                                        },
                                        {
                                            "id": 112553,
                                            "module_name": "access-map",
                                            "alias": "Users Access Map",
                                            "module_path": "access-map",
                                            "module_option": "origin",
                                            "module_icon": "zmdi-map",
                                            "is_active": true,
                                            "parent_name": "master-data",
                                            "features": [
                                                {
                                                    "name": "read",
                                                    "status": true
                                                },
                                                {
                                                    "name": "create",
                                                    "status": true
                                                },
                                                {
                                                    "name": "edit",
                                                    "status": true
                                                },
                                                {
                                                    "name": "delete",
                                                    "status": true
                                                },
                                                {
                                                    "name": "report",
                                                    "status": true
                                                }
                                            ],
                                            "children": []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": 112477,
                            "module_name": "vehicle-maintenance",
                            "alias": "Perawatan Aset",
                            "module_path": "vehicle-maintenance",
                            "module_option": "embedd",
                            "module_icon": "zmdi-wrench",
                            "is_active": true,
                            "parent_name": "vehicle-maintenance",
                            "features": [
                                {
                                    "name": "read",
                                    "status": true
                                },
                                {
                                    "name": "create",
                                    "status": true
                                },
                                {
                                    "name": "edit",
                                    "status": true
                                },
                                {
                                    "name": "delete",
                                    "status": true
                                },
                                {
                                    "name": "report",
                                    "status": true
                                }
                            ],
                            "children": [
                                {
                                    "id": 112507,
                                    "module_name": "service-type",
                                    "alias": "Tipe Perbaikan",
                                    "module_path": "service-type",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-wrench",
                                    "is_active": true,
                                    "parent_name": "vehicle-maintenance",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112511,
                                    "module_name": "workshop",
                                    "alias": "Bengkel",
                                    "module_path": "workshop",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-collection-bookmark",
                                    "is_active": true,
                                    "parent_name": "vehicle-maintenance",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112537,
                                    "module_name": "work-order",
                                    "alias": "Riwayat Perbaikan",
                                    "module_path": "work-order",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-assignment-returned",
                                    "is_active": true,
                                    "parent_name": "vehicle-maintenance",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112601,
                                    "module_name": "service-remainder",
                                    "alias": "Pengingat Perbaikan",
                                    "module_path": "service-reminder",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-wrench",
                                    "is_active": true,
                                    "parent_name": "vehicle-maintenance",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                }
                            ]
                        },
                        {
                            "id": 112468,
                            "module_name": "control-monitoring",
                            "alias": "Kontrol & Monitoring",
                            "module_path": "control-monitoring",
                            "module_option": "embedd",
                            "module_icon": "zmdi-desktop-windows",
                            "is_active": true,
                            "parent_name": "control-monitoring",
                            "features": [
                                {
                                    "name": "read",
                                    "status": true
                                },
                                {
                                    "name": "create",
                                    "status": true
                                },
                                {
                                    "name": "edit",
                                    "status": true
                                },
                                {
                                    "name": "delete",
                                    "status": true
                                },
                                {
                                    "name": "report",
                                    "status": true
                                }
                            ],
                            "children": [
                                {
                                    "id": 171165,
                                    "module_name": "mapv2",
                                    "alias": "Monitoring Aset",
                                    "module_path": "maps-monitoring",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-google-maps",
                                    "is_active": true,
                                    "parent_name": "control-monitoring",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 187048,
                                    "module_name": "dashboard-reminder",
                                    "alias": "Dokumen Aset",
                                    "module_path": "dashboard-reminder",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-library",
                                    "is_active": true,
                                    "parent_name": "control-monitoring",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 186367,
                                    "module_name": "report-sensorv2",
                                    "alias": "Laporan Sensor",
                                    "module_path": "report-sensorv2",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-chart",
                                    "is_active": true,
                                    "parent_name": "control-monitoring",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 180919,
                                    "module_name": "fleetv2",
                                    "alias": "Laporan Armada",
                                    "module_path": "fleetv2",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-dns",
                                    "is_active": true,
                                    "parent_name": "control-monitoring",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 181600,
                                    "module_name": "trip-v2",
                                    "alias": "Laporan Perjalanan",
                                    "module_path": "trip-v2",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-dns",
                                    "is_active": true,
                                    "parent_name": "control-monitoring",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                }
                            ]
                        },
                        {
                            "id": 112510,
                            "module_name": "vehicle-log",
                            "alias": "Riwayat Aset",
                            "module_path": "vehicle-log",
                            "module_option": "origin",
                            "module_icon": "zmdi-car-wash",
                            "is_active": true,
                            "parent_name": "vehicle-log",
                            "features": [
                                {
                                    "name": "read",
                                    "status": true
                                },
                                {
                                    "name": "create",
                                    "status": true
                                },
                                {
                                    "name": "edit",
                                    "status": true
                                },
                                {
                                    "name": "delete",
                                    "status": true
                                },
                                {
                                    "name": "report",
                                    "status": true
                                }
                            ],
                            "children": [
                                {
                                    "id": 112431,
                                    "module_name": "vehicle-transfer",
                                    "alias": "Transfer Aset",
                                    "module_path": "vehicle-transfer",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-swap",
                                    "is_active": true,
                                    "parent_name": "vehicle-log",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112472,
                                    "module_name": "vehicle-disposal",
                                    "alias": "Disposal Aset",
                                    "module_path": "vehicle-disposal",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-car-taxi",
                                    "is_active": true,
                                    "parent_name": "vehicle-log",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112430,
                                    "module_name": "vehicle-write-off",
                                    "alias": "Write Off Asset",
                                    "module_path": "vehicle-write-off",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-grid-off",
                                    "is_active": true,
                                    "parent_name": "vehicle-log",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112436,
                                    "module_name": "vehicle-accident",
                                    "alias": "Kerusakan Aset",
                                    "module_path": "vehicle-accident",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-bus",
                                    "is_active": true,
                                    "parent_name": "vehicle-log",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                }
                            ]
                        },
                        {
                            "id": 112450,
                            "module_name": "order-manage",
                            "alias": "Job Order",
                            "module_path": "order-management",
                            "module_option": "origin",
                            "module_icon": "zmdi-assignment",
                            "is_active": true,
                            "parent_name": "order-manage",
                            "features": [
                                {
                                    "name": "read",
                                    "status": true
                                },
                                {
                                    "name": "create",
                                    "status": true
                                },
                                {
                                    "name": "edit",
                                    "status": true
                                },
                                {
                                    "name": "delete",
                                    "status": true
                                },
                                {
                                    "name": "report",
                                    "status": true
                                }
                            ],
                            "children": [
                                {
                                    "id": 112512,
                                    "module_name": "order-assignment",
                                    "alias": "Penugasan & Monitoring Pekerjaan",
                                    "module_path": "monitoring-dispatch-mab",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-assignment",
                                    "is_active": true,
                                    "parent_name": "order-manage",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 182281,
                                    "module_name": "gantt-monitoring",
                                    "alias": "Reservasi Ketersediaan Aset",
                                    "module_path": "gantt-monitoring",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-laptop-chromebook",
                                    "is_active": true,
                                    "parent_name": "order-manage",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112518,
                                    "module_name": "report-shipment",
                                    "alias": "Laporan Pekerjaan",
                                    "module_path": "report-shipment",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-assignment",
                                    "is_active": true,
                                    "parent_name": "order-manage",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112538,
                                    "module_name": "total-shipment",
                                    "alias": "Total Pekerjaan",
                                    "module_path": "total-shipment",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-assignment",
                                    "is_active": true,
                                    "parent_name": "order-manage",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112552,
                                    "module_name": "shipment-driver",
                                    "alias": "Pekerjaan Per Pengemudi",
                                    "module_path": "detail-shipment-driver",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-assignment-account",
                                    "is_active": true,
                                    "parent_name": "order-manage",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 112454,
                                    "module_name": "shipment-vehicle",
                                    "alias": "Perjalanan Per Kendaraan",
                                    "module_path": "detail-shipment-vehicle",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-truck",
                                    "is_active": true,
                                    "parent_name": "order-manage",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                },
                                {
                                    "id": 167776,
                                    "module_name": "report-and-monitoring-driver-shipment",
                                    "alias": "Laporan Monitoring Pengemudi",
                                    "module_path": "report-and-monitoring-driver-shipment",
                                    "module_option": "origin",
                                    "module_icon": "zmdi-desktop-mac",
                                    "is_active": true,
                                    "parent_name": "order-manage",
                                    "features": [
                                        {
                                            "name": "read",
                                            "status": true
                                        },
                                        {
                                            "name": "create",
                                            "status": true
                                        },
                                        {
                                            "name": "edit",
                                            "status": true
                                        },
                                        {
                                            "name": "delete",
                                            "status": true
                                        },
                                        {
                                            "name": "report",
                                            "status": true
                                        }
                                    ],
                                    "children": []
                                }
                            ]
                        }
                    ]
                    const data_menu = JSON.stringify(signInUserApi.data.data.company === 746 ? data_menu_obj : data_modules)
                    // const data_menu = JSON.stringify(data_modules)
                    
                    yield put({type: SET_MENU, payload: data_modules})
/*                     sessionStorage.setItem('menu_user', data_menu);
                    sessionStorage.setItem('user_id', signInUserApi.data.data.id);
                    sessionStorage.setItem('apiKey', signInUserApi.data.data.apikey);
                    sessionStorage.setItem('rolename', signInUserApi.data.data.role_name);
                    sessionStorage.setItem('name', signInUserApi.data.data.fullname);
                    sessionStorage.setItem('companyId', signInUserApi.data.data.company);
                    sessionStorage.setItem('package', signInUserApi.data.data.package_name); */

                    localStorage.setItem('menu_user', data_menu);
                    localStorage.setItem('user_id', signInUserApi.data.data.id);
                    localStorage.setItem('apiKey', signInUserApi.data.data.apikey);
                    localStorage.setItem('apikey_jyoti', signInUserApi.data.data.apikey_jyoti);
                    localStorage.setItem('rolename', signInUserApi.data.data.role_name);
                    localStorage.setItem('name', signInUserApi.data.data.fullname);
                    localStorage.setItem('companyId', signInUserApi.data.data.company);
                    localStorage.setItem('package', signInUserApi.data.data.package_name);
                    yield put(userSignInSuccess(signInUserApi));
                } else {
                    yield put(showAuthMessage(menu.data.message))
                }
            }
        else 
            yield put(showAuthMessage("Oops! can't connected to server"));
            
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

function* signOut() {
    try {
        const signOutUser = yield call(signOutRequest);
        // console.log(signOutUser)
        if (signOutUser !== 'ok') {
            yield put(showAuthMessage(signOutUser.message));
        } else {
            // console.log('run signout')
            /* sessionStorage.removeItem('user_id');
            sessionStorage.removeItem('apiKey');
            sessionStorage.removeItem('rolename');
            sessionStorage.removeItem('name');
            sessionStorage.removeItem('menu_user');
            sessionStorage.removeItem('companyId'); */

            localStorage.removeItem('user_id');
            localStorage.removeItem('apiKey');
            localStorage.removeItem('rolename');
            localStorage.removeItem('name');
            localStorage.removeItem('menu_user');
            localStorage.removeItem('companyId');
            yield put(userSignOutSuccess(signInUser));
        }
    } catch (error) {
        console.log("error login")
        yield put(showAuthMessage(error));
    }
}

function* setRefreshToken(data) {
    const {username, password} = data.action
    try {
        // console.log(data)
        // console.log(`username: ${username}, password: ${password}`)
    } catch (error) {
        // console.log(error)
    }
}

function* setCreateToken() {
    try {
        // console.log('create token')
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

export function* createUserAccount() {
    yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInWithGoogle() {
    yield takeEvery(SIGNIN_GOOGLE_USER, signInUserWithGoogle);
}

export function* signInWithFacebook() {
    yield takeEvery(SIGNIN_FACEBOOK_USER, signInUserWithFacebook);
}

export function* signInWithTwitter() {
    yield takeEvery(SIGNIN_TWITTER_USER, signInUserWithTwitter);
}

export function* signInWithGithub() {
    yield takeEvery(SIGNIN_GITHUB_USER, signInUserWithGithub);
}

export function* signInUser() {
    yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
    yield takeEvery(SIGNOUT_USER, signOut);
}

export function* refreshToken() {
    yield takeEvery(REQ_REFRESH_TOKEN, setRefreshToken);
}

export function* createToken() {
    yield takeEvery(REQ_CREATE_TOKEN, setCreateToken);
}

export default function* rootSaga() {
    yield all([fork(signInUser),
        fork(createUserAccount),
        fork(signInWithGoogle),
        fork(signInWithFacebook),
        fork(signInWithTwitter),
        fork(signInWithGithub),
        fork(refreshToken),
        fork(createToken),
        fork(signOutUser)]);
}


// WEBPACK FOOTER //
// ./sagas/Auth.js